<div class="grid grid-cols-5 w-full h-full bg-transparent px-2">
  <ion-tab-button
    appRipple
    class="bg-transparent h-full"
    [routerLink]="'/home'"
    routerLinkActive="active-tab"
    #rlaHome="routerLinkActive"
  >
    <home-icon
      [color]="rlaHome.isActive ? 'var(--ion-color-primary)' : '#9ca3af'"
      [width]="'22'"
      [height]="'22'"
      class="mb-1"
    />
    <span class="text-[9px] font-bold uppercase tracking-widest transition-colors duration-300" 
          [class.text-primary]="rlaHome.isActive"
          [class.text-gray-400]="!rlaHome.isActive">Inicio</span>
  </ion-tab-button>

  <ion-tab-button
    appRipple
    class="bg-transparent h-full"
    [routerLink]="'/freights/list'"
    routerLinkActive="active-tab"
    #rlaList="routerLinkActive"
  >
    <freight-icon
      [color]="rlaList.isActive ? 'var(--ion-color-primary)' : '#9ca3af'"
      [width]="'22'"
      [height]="'22'"
      class="mb-1"
    />
    <span class="text-[9px] font-bold uppercase tracking-widest transition-colors duration-300" 
          [class.text-primary]="rlaList.isActive"
          [class.text-gray-400]="!rlaList.isActive">Mis Fletes</span>
  </ion-tab-button>

  <ion-tab-button
    appRipple
    class="bg-transparent h-full"
    [routerLink]="'/freights/add'"
    routerLinkActive="active-tab"
    #rlaAdd="routerLinkActive"
  >
    <div class="w-9 h-9 bg-primary-50 rounded-lg flex items-center justify-center text-gray-400 group-hover:bg-primary group-hover:text-white transition-all shadow-sm mb-1" 
         [class.bg-primary]="rlaAdd.isActive" 
         [class.text-white]="rlaAdd.isActive">
      <ion-icon name="add" class="text-xl"></ion-icon>
    </div>
    <span class="text-[9px] font-bold uppercase tracking-widest transition-colors duration-300" 
          [class.text-primary]="rlaAdd.isActive"
          [class.text-gray-400]="!rlaAdd.isActive">Publicar</span>
  </ion-tab-button>

  <ion-tab-button
    appRipple
    class="bg-transparent h-full"
    [routerLink]="'/notifications'"
    routerLinkActive="active-tab"
    #rlaNotif="routerLinkActive"
    (click)="resetBadge()"
  >
    <div class="relative mb-1">
        <ion-icon name="notifications-outline" 
                  [style.color]="rlaNotif.isActive ? 'var(--ion-color-primary)' : '#9ca3af'" 
                  class="text-xl"></ion-icon>
        <notification-badge
          *ngIf="notificationNumber > 0"
          [notificationNumber]="notificationNumber"
          class="absolute -top-1 -right-1"
        />
    </div>
    <span class="text-[9px] font-bold uppercase tracking-widest transition-colors duration-300" 
          [class.text-primary]="rlaNotif.isActive"
          [class.text-gray-400]="!rlaNotif.isActive">Alertas</span>
  </ion-tab-button>

  <ion-tab-button
    appRipple
    class="bg-transparent h-full"
    [routerLink]="'/profile'"
    routerLinkActive="active-tab"
    #rlaProfile="routerLinkActive"
  >
    <user-icon
      [color]="rlaProfile.isActive ? 'var(--ion-color-primary)' : '#9ca3af'"
      [width]="'22'"
      [height]="'22'"
      class="mb-1"
    />
    <span class="text-[9px] font-bold uppercase tracking-widest transition-colors duration-300" 
          [class.text-primary]="rlaProfile.isActive"
          [class.text-gray-400]="!rlaProfile.isActive">Perfil</span>
  </ion-tab-button>
</div>
